module.exports = __webpack_public_path__ + "static/media/rScott.55889928.jpeg";